// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import * as flags from 'country-flag-icons/react/3x2';
import {Text} from '../text';
import {Tooltip} from '../tooltip';
import {code2name} from './util.js';
import * as cns from './country.module.less';

export function Country({
    className,
    code: input,
    show_code,
    is_round,
    font_size='xs',
})
{
    const code = input?.toUpperCase();
    const Comp = flags[code];
    let content = Comp ? <Comp className={cns.flag}/> : null;
    if (is_round)
        content = <span className={cns.circle_wrap}>{content}</span>;
    const Txt_comp = Text[font_size] ?? Text.xs;
    return <Tooltip tip={code2name(code)} placement="right">
      <span className={cn(cns.root, className)}>
        {content}
        {show_code ? <Txt_comp className={cns.code}>{code}</Txt_comp> : null}
      </span>
    </Tooltip>;
}
